import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { ApprovalProvider } from '../centerWarehouse/partnerInternalRequest/ContextAPI';
import Index from '../centerWarehouse/partnerInternalRequest/Index';
import PermissionDenied from './PermissionDenied';

export default function PartnerInternalRequestCentral() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['partner-internal-request-central-init']) return <PermissionDenied />;

    return (
        <ApprovalProvider>
            <Index />
        </ApprovalProvider>
    );
}
